export const WT_AD_BLOCK_INITIALIZED = 'wtAdBlockInitialized';
